import useHashObserver from '../hooks/use-hash-observer';

function HashObserver() {
  useHashObserver();
  return null;
}

export default HashObserver;
